import {
  CUSTOM_FIELD_STATUSES,
  CUSTOM_FIELD_TYPES,
  CustomFieldObjectConfigMapSchema,
  CustomFieldOptionsSchema,
} from '@clockwise/shared';
import { z } from 'zod';

// Re-export shared constants + types so callers don't have to depend on
// @clockwise/shared directly to drive their UI.
export {
  CUSTOM_FIELD_OBJECT_LABELS,
  CUSTOM_FIELD_OBJECTS,
  CUSTOM_FIELD_STATUSES,
  CUSTOM_FIELD_TYPE_LABELS,
  CUSTOM_FIELD_TYPES,
  type CustomFieldObject,
  type CustomFieldObjectConfig,
  type CustomFieldObjectConfigMap,
  type CustomFieldOptions,
  type CustomFieldStatus,
  type CustomFieldType,
  type CustomFieldValue,
  type CustomFieldValues,
  getObjectFlags,
} from '@clockwise/shared';

const ObjectConfig = CustomFieldObjectConfigMapSchema;
const Options = CustomFieldOptionsSchema;

export const CustomFieldSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  label: z.string(),
  key: z.string(),
  fieldType: z.enum(CUSTOM_FIELD_TYPES),
  options: Options.nullable(),
  objectConfig: ObjectConfig,
  status: z.enum(CUSTOM_FIELD_STATUSES),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CustomField = z.infer<typeof CustomFieldSchema>;

const CreateBody = z.object({
  label: z.string(),
  key: z.string(),
  fieldType: z.enum(CUSTOM_FIELD_TYPES),
  options: Options.nullable().optional(),
  objectConfig: ObjectConfig.optional(),
});

export const CreateCustomFieldInput = CreateBody;
export type CreateCustomFieldInput = z.infer<typeof CreateCustomFieldInput>;

export const PatchCustomFieldInput = z.object({
  label: z.string().optional(),
  options: Options.nullable().optional(),
  objectConfig: ObjectConfig.optional(),
  status: z.enum(CUSTOM_FIELD_STATUSES).optional(),
});
export type PatchCustomFieldInput = z.infer<typeof PatchCustomFieldInput>;

export interface ListCustomFieldsQuery {
  q?: string;
  status?: (typeof CUSTOM_FIELD_STATUSES)[number];
  fieldType?: (typeof CUSTOM_FIELD_TYPES)[number];
  sortField?: 'label' | 'key' | 'fieldType' | 'status' | 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}
